import React, { useCallback, useEffect } from 'react';
import AuthorizationLayout from '../../Layout/AuthorizationLayout';
import recoveryImage from '../../../../assets/images/recovery.svg';
import AuthorizationLayoutTablet from '../../Layout/Tablet/AuthorizationLayoutTablet';
import PasswordConfirmForm from '../../../Features/PasswordConfirmForm/PasswordConfirmForm';
import { useTranslation } from 'react-i18next';
import StepTitle from '../../Features/StepTitle/StepTitle';
import StepDescription from '../../Features/StepDescription/StepDescription';
import { useDispatch } from 'react-redux';
import { confirmInvite } from './signUpByInviteSlice';
import { useNavigate, useParams } from 'react-router-dom';
import { useNotification } from '../../../Common/Notification/notify';
import { useAppSelector } from '../../../../config/redux/hooks';
import useNotifyOnError from '../../../../common/form/useNotifyOnError';
import AppRoutes from '../../../App/AppRoutes';

function SignUpByInvitePage() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { token } = useParams();
  const notify = useNotification();
  const navigate = useNavigate();
  const readyToLogin = useAppSelector(state => state.auth.signupByInvite.readyToLogin);
  const error = useAppSelector(state => state.auth.signupByInvite.error);
  useNotifyOnError(error);

  useEffect(() => {
    if (readyToLogin) {
      navigate(`/${AppRoutes.AUTH_PATH}`);
    }
  }, [readyToLogin]);

  const onSubmit = useCallback(
    values => {
      if (!token) {
        notify.error(t('common.notification.code.missing'));
        return;
      }
      dispatch(confirmInvite({ token, password: values.password }));
    },
    [token],
  );

  return (
    <AuthorizationLayout background={recoveryImage} backgroundStyle={{ backgroundSize: '34rem', backgroundPosition: 'center' }}>
      <AuthorizationLayoutTablet>
        <StepTitle>{t('signup.by.invite.title')}</StepTitle>
        <StepDescription>{t('signup.by.invite.description')}</StepDescription>
        <PasswordConfirmForm submitButtonLabel={t('common.button.next')} onSubmit={onSubmit} />
      </AuthorizationLayoutTablet>
    </AuthorizationLayout>
  );
}

export default SignUpByInvitePage;
